import React from 'react';
import { Dots } from '@cleartrip/bento';
import classNames from "classnames";
function Dropdown(props) {
	return (
		<ul
			className={classNames('br-4 bg-white p-1 p-absolute mt-1 w-100p z-10', props.className)}
			style={{
				boxShadow: 'rgba(0, 0, 0, 0.24) 0px 4px 12px 0px',
				overflowY: 'auto',
				maxHeight: '194px',
        minWidth: '170px',
			}}
		>
			{props.loading ? (
				<div className='flex flex-center flex-middle p-4'>
					<Dots height={8} color="#36c" />
				</div>
			) : (
				props.children
			)}
		</ul>
	);
}
export default Dropdown;
